<script>
import Customers from '@/services/Customers';
import ModalViewEmailEvent from "@/components/modals/customers/modalViewEmailEvent";

export default {
  props: ['messageId', 'messageData'],
  components: { ModalViewEmailEvent },
  data() {
    return {
      isBusy: false,
      showModal: false,
      emailDetails: [],
      searchQuery: '',
      emailDetailsLoader: false,
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "event_datetime",
      sortDesc: true,
      eventData: [],
      tableFields: [

        {
          key: "eventType",
          label: "Event Type",
          sortable: true,
        },
        {
          key: "eventTypeDetail",
          label: "Event Type Detail",
          sortable: true,
        },
        {
          key: "diagnostic_code",
          label: "Diagnostic Code",
          sortable: true,
          thStyle: { width: '50%' }
        },
        {
          key: "event_datetime",
          label: "Event Datetime",
          sortable: true,
        },
        "Action"
      ]
    };
  },

  methods: {

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    async getEmailsStats(filters = {}) {
      try {
        this.toggleBusy();
        this.loaderCountEmails = true;

        // Build query params
        const params = new URLSearchParams(filters).toString();
        const response = await Customers.getEmailsStats(params);
        const emails = response.data.data.emails || [];

        // Table data
        this.tableData = emails;
        this.totalRows = emails.length;

      } catch (error) {
        this.error = error.response?.data?.error || "";
        this.tableData = [];
        this.totalRows = 0;

      } finally {
        this.toggleBusy();
        this.loaderCountEmails = false;
      }
    },

    closeModal() {
      this.showModal = false
    },

    showData(){
      this.getEmailsStats({ messageId: this.messageId })
    },

    resetProps(){
      this.tableData = []
    },

    viewEventDetails(item){
      this.eventData = item;
      this.$bvModal.show("view_event_details");
    }

  }
}
</script>

<template>
  <b-modal @shown="showData" @hidden="resetProps" v-model="showModal" id="view_message_events" title="View Email Details" title-class="font-18" size="xl" centered>
    <div class="card">
      <div class="card-body">
        <template>
          <h4>Summary</h4>
          <div class="row">
            <div class="col-12">
              <div class="col-sm-12 col-md-12"><strong>Message ID: {{messageData.messageId}}</strong></div>
            </div>
            <div class="col-4">
              <div class="col-sm-12 col-md-12"><strong>Message From:</strong> {{messageData.from}}</div>
              <div class="col-sm-12 col-md-12"><strong>Message To:</strong> {{messageData.to}}</div>
            </div>
            <div class="col-4">
              <div class="col-sm-12 col-md-12"><strong>Subject:</strong> {{messageData.subject}}</div>
              <div class="col-sm-12 col-md-12"><strong>Email Type:</strong> {{messageData.email_type}}</div>
            </div>
            <div class="col-4">
              <div class="col-sm-12 col-md-12"><strong>Recipient ISP:</strong> {{messageData.recipient_isp}}</div>
              <div class="col-sm-12 col-md-12"><strong>Source ISP:</strong> {{messageData.source_isp}}</div>
            </div>
          </div>

          <hr/>

          <div class="row">
            <div class="col-12">
              <h4>Email Events</h4>
            </div>
            <div class="col-12">
              <!-- Table -->
              <div class="mb-0">
                <b-table
                    :busy="isBusy"
                    :items="tableData"
                    :fields="tableFields"
                    responsive
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    show-empty
                    empty-text="No Data Found"
                    @filtered="onFiltered"
                >

                  <template v-slot:cell(action)="data">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a href="javascript:void(0);" class="px-2 text-primary"
                           title="View Event Details" @click="viewEventDetails(data.item)">
                          <i class="uil uil-eye font-size-18"></i>
                        </a>
                      </li>
                    </ul>
                  </template>

                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>

                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>



        </template>
      </div>
    </div>

    <ModalViewEmailEvent :eventData="eventData"></ModalViewEmailEvent>
  </b-modal>
</template>



